import { extraEntries } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";
import TagChip from "./TagChip";

export default function ExtraSection() {
  return (
    <section id="extra" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="番外合集"
          title="漂亮的小姨子番外：五种常见类型与阅读时机"
          desc="番外之间的差异主要在“讲什么”和“什么时候读”。下面把常见的几类分开说明，并给出各自更适合的打开方式。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          {extraEntries.map((entry) => (
            <article
              key={entry.id}
              className="relative rounded-lg bg-background-50 border border-background-200 border-l-4 border-l-accent-500 p-5 md:p-6"
            >
              <div className="flex items-start gap-4">
                <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 text-xl">
                  <i className={entry.icon}></i>
                </span>
                <div className="flex-1">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{entry.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{entry.subtitle}</p>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {entry.tags.map((tag) => (
                      <TagChip key={tag} variant="accent">
                        {tag}
                      </TagChip>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}